// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2Deku","box":"WorkspacesBox_box__3qAmh","node":"WorkspacesBox_node__2Wr6f"};